import React from 'react';

import { useDispatch } from 'react-redux';

import { closestCenter, DndContext, type DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import {
  changeTasksOrder,
  setSelectedRegionTask,
} from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import { useAppSelector } from 'src/store/store';

import SortableRegionTaskRow from './sortableRegionTaskRow';

/**
 * Default component.
 */
const SortableRegionTaskList = () => {
  const { selectedRegionTasks } = useAppSelector((state) => state.regionTasksConfigPage);
  const dispatch = useDispatch();
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event: DragEndEvent) => {
    const target = event.activatorEvent.target as HTMLElement;
    const index = event.active.data.current?.sortable.index;
    // If the target is a button or is within a button, we don't want to move it, 
    // and open the modal instead
    if (!target.closest('button')) {
      const newIndex = event.over?.data.current?.sortable.index;
      dispatch(changeTasksOrder({ old: index, new: newIndex }));
    } else {
      dispatch(setSelectedRegionTask(selectedRegionTasks[index]));
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext
        items={selectedRegionTasks.map((regionTask) => regionTask.taskId)}
        strategy={verticalListSortingStrategy}
      >
        {selectedRegionTasks.map((task) => (
          <SortableRegionTaskRow task={task} key={task.taskId} />
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default SortableRegionTaskList;
